import { Box, Stack, Typography } from "@mui/material"
import { FormProps } from "./StepForm"

type Props = {
  forms: Array<FormProps>
  values: Record<string, string|number>
}

export const StepFormConfirm = (props: Props) => {
  const { forms, values } = props

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const valueContent = (value: any, type: string) => {
    switch (type) {
      case 'checkbox':
        return value ? 'はい' : 'いいえ'
      case 'upload':
        return value && <img src={value.data as string} width={50} />
      default:
        return value
    }
  }

  return (
    <Box
      m={2}
      // height="75vh"
      display="flex"
      justifyContent="center"
      justifyItems="center"
      alignItems="top"
      mt={5}
    >
      <Stack sx={{ border: 1 }}>
        {
          forms && forms.map((form: FormProps) => {
            return (
              <Box display="flex" width="auto" justifyContent="space-between" sx={{ border: 1, borderColor: "black", padding: 1 }}>
                <Box><Typography variant="button">{form.label}</Typography></Box>
                <Box alignContent="center" ml={2}><Typography variant="body2">{valueContent(values[form.name], form.type)}</Typography></Box>
              </Box>
            )
          })
        }
      </Stack>
    </Box>
  )
}
